import SlsCorClient from '@/api/SistemaDKP/sls-cor.client';
import store from '@/store';
import EsMarcaClient from '@/api/SistemaDKP/sls-marca.client';
import Notifier from '@/libs/Notifier';

export default class SlsEmbalagService {
  constructor() {
    this.client = new SlsCorClient();
    this.clientMarca = new EsMarcaClient();
    this.store = store;
    this.notify = new Notifier();
  }

  async index(query) {
    try {
      const { data, ...pagination } = await this.client.getCores({ ...this.store.getters['slsCor/getFilters'], ...query });
      this.store.commit('slsCor/setCores', data);
      this.store.commit('slsCor/setFilters', pagination);
      return data;
    } catch (error) {
      console.log(error);
    }
  }
}
